export default `
  mutation addUsersToEnterprisePlan($users: [StripeUserInput]!) {
    addUsersToEnterprisePlan(users: $users) {
      success
      message
      quantityExceeded
      currentCount
      quantity
    }
  }
`
